import registro from './Registro/Registro'

const sicpe = {
  registro: registro
}

export default sicpe


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPE/sistema/sistemasSICPE.js
// module id = null
// module chunks = 